const POPPER_REFERENCE_HIDDEN_ATTRIBUTE = 'data-popper-reference-hidden';
/**
 * Defines a Popper modifier that will close a Popper-controlled layer
 * component by setting `pvdOpen` to `false`. Modifier can be disabled by
 * setting `pvdDisableOverflow` to `true`.
 *
 * @param componentName - the name of layer component that will be used to name the CustomEvent
 *
 * @emits
 * pvd-{{componentName}}-reference-hidden
 */
function getCloseIfTriggerHiddenPopperModifier(componentName) {
    return {
        name: 'closeIfTriggerHidden',
        enabled: !this.pvdDisableOverflow,
        phase: 'beforeWrite',
        requires: ['hide'],
        fn: ({ state }) => {
            if (this.pvdDisableOverflow) {
                return;
            }
            const isTriggerHidden = state.attributes.popper && state.attributes.popper[POPPER_REFERENCE_HIDDEN_ATTRIBUTE];
            if (this.pvdOpen && isTriggerHidden) {
                this.dispatchEvent(new CustomEvent(`pvd-${componentName}-reference-hidden`));
                this.pvdOpen = false;
            }
        },
    };
}

export { getCloseIfTriggerHiddenPopperModifier };
//# sourceMappingURL=get-close-if-trigger-hidden-popper-modifier.js.map
